import GuidedSearchBoard from "../../../../../features/browse-search/components/GuidedSearchBoard";
import BaseCategoryPage from "../../../CategoryPage";

export const CategoryPage = (props) => (
  <BaseCategoryPage
    {...props}
    hideHeaderDescription
    topContent={<GuidedSearchBoard withCategoryDescription />}
  />
);

export default CategoryPage;
